import type * as React from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

export const Wrapper = styled.div<{ bgDesktop?: string; bgMobile?: string }>`
  background-image: ${({ bgMobile }) => `url(${bgMobile})` || 'none'};
  background-position: top center;
  background-repeat: no-repeat;
  background-origin: top;
  background-size: cover;

  ${({ theme }) => theme.breakpoints.up('md')} {
    min-height: 640px;
    background-image: ${({ bgDesktop }) => `url(${bgDesktop})` || 'none'};
  }
`;

export const RightContent = styled.div`
  max-width: 540px;
`;

const ChipWrapper = styled.div`
  background: linear-gradient(
    163.68deg,
    rgba(77, 77, 77, 0.2) 14.79%,
    rgba(145, 145, 145, 0) 141.37%,
    rgba(44, 35, 15, 0.05) 141.37%
  );
  backdrop-filter: blur(80px);
  border-radius: 15px;
`;

export const CustomChip: React.FC<
  React.PropsWithChildren<{ text: string }>
> = ({ text }) => (
  <ChipWrapper className="tw-font-pop text-white font-extrabold text-16 leading-22 w-200 sm:w-160 h-52  flex items-center justify-center text-center">
    {text}
  </ChipWrapper>
);

export const PremiumCardWrapper = styled.div<{ isHighlighted: boolean }>`
  width: 100%;
  max-width: 300px;
  height: 280px;
  border-width: ${({ isHighlighted }) => (isHighlighted ? '3px' : '0px')};

  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 360px;
    max-width: 360px;
    height: 300px;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    max-width: 380px;
    width: 380px;
    height: 320px;
  }
`;

export const SliderWrapper = styled.div`
  width: 100%;
  max-width: 300px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 360px;
    max-width: 360px;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    max-width: 380px;
    width: 380px;
  }
`;
